import { render, staticRenderFns } from "./EventCustomQuestions.vue?vue&type=template&id=542a3fc9"
import script from "./EventCustomQuestions.vue?vue&type=script&lang=js"
export * from "./EventCustomQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports